import axios from 'axios';

const instance = axios.create();
const context = `${window.appConfig.API}/generali/v1/public`;

instance.interceptors.request.use(async config => {
  config.headers = {
   'Content-Type': 'application/json',
  };

  return config;
}, error => {
  Promise.reject(error)
});

instance.interceptors.response.use(response => {
  return response
}, async function (error) {
  const originalRequest = error.config;

  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    return instance(originalRequest);
  }
  return Promise.reject(error);
});

export function getFunds(filters: any) {
  const urlParams = new URLSearchParams();
  filters?.text && urlParams.set('q', filters.text);
  filters?.fundType && urlParams.set('productTypeCode', filters.fundType);
  filters?.subFundType && urlParams.set('subProductTypeCode', filters.subFundType);
  filters?.geographic && urlParams.set('regionCode', filters.geographic);
  filters?.management && urlParams.set('fundHouse', filters.management);
  filters?.risk && urlParams.set('riskId', `${filters.risk}`);
  (filters?.esg === true || filters?.esg === false) && urlParams.set('esg', `${filters.esg}`);
  (filters?.tradeable === true || filters?.tradeable === false) && urlParams.set('tradeable', `${filters.tradeable}`);
  filters?.fundsExcluded && urlParams.set('fundsExcluded', filters.fundsExcluded);
  filters?.fundsIgnored && urlParams.set('fundsIgnored', filters.fundsIgnored);

  const url = `${context}/instruments/search?${urlParams.toString()}`;
  return instance.get(url).then(res => res.data);
}

export function getFundType() {
  return instance.get(`${context}/masterdatas/producttypes/search`).then(res => res.data);
}

export function getSubFundType() {
  return instance.get(`${context}/masterdatas/subproducttypes/search`).then(res => res.data);
}

export function getGeographic() {
  return instance.get(`${context}/masterdatas/geographicareas/search`).then(res => res.data);
}

export function getManagement() {
  return instance.get(`${context}/masterdatas/fundhouses/search`).then(res => res.data);
}

export function getRisk() {
  return instance.get(`${context}/masterdatas/riskprofiles/search`).then(res => res.data);
}

const details = new Map([]);

export function getDetails(id: string): Promise<any> {
  return new Promise((resolve, reject) => {
    if (details.has(id)) {
      resolve(details.get(id));
    }
  
    return instance.get(`${context}/analysis/instruments/${id}`)
      .then(res => {
        details.set(id, res.data)
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
